import  {baseActions}  from "./base.actions";

export const certificationTypeActions = {
   
    gets,
    get,
    
};


function gets() {
    return baseActions.getall('certificationtype');
}

function get(id)
{
    return baseActions.get('certificationtype',id);
}
